<template>
  <div class="vacancy-filter">
    <GeneralElementsSearch
      :placeholder="$t('vacancies.filter.search.placeholder')"
      @update="handleSearch"
    />
    <div class="teams-title h6">
      {{ $t('vacancies.filter.teamTitle') }}
    </div>
    <VacancyFilterMultiselect :blok="multiselectBlok" />
  </div>
</template>

<script setup lang="ts">
  import { useFilterStore } from '~/stores'

  defineProps<{
    blok: any
  }>()

  const { t } = useI18n()
  const filterStore = useFilterStore()

  const multiselectBlok = {
    placeholder: t('vacancies.filter.select')
  }

  function handleSearch(value: string) {
    filterStore.search = value
  }
</script>

<style lang="scss" scoped>
  @import '~/assets/styles/common.scss';

  .vacancy-filter {
    align-items: center;
    display: flex;
    flex-direction: column;

    > div {
      &:not(:last-child) {
        margin-bottom: rem(24);
      }
    }

    .teams-title {
      display: none;

      @include tablet-up {
        background-color: $bt-green;
        display: block;
        max-width: 328px;
        padding: rem(8);
        text-align: center;
        width: calc(100% - 16px);
      }

      h6 {
        margin: 0;
      }
    }
  }
</style>
